import * as React from "react";
import { Modal } from "react-bootstrap";

import CloseIcon from "assets/icons/close.svg";
import RectangleIcon from "assets/icons/bidding/mobile/rectangleModal.svg";

import "./styles.scss";

interface MobileModalProps {
  htmlContent?: string;
  children?: React.ReactNode;
  id?: string;
  onHide: () => void;
  show: boolean;
  showCopyright?: boolean;
  title?: string;
  modalHeight?: string;
}

const MobileModal = ({
  htmlContent = "",
  children,
  id,
  show,
  showCopyright = true,
  onHide,
  title,
  modalHeight = "calc(100vh - 120px)"
}: MobileModalProps) => {
  return (
    <Modal
      id={id}
      aria-labelledby={id ? `${id}-title` : undefined}
      show={show}
      centered
      className="mobile-bidding-modal-wrapper"
      onHide={onHide}>
      <div
        className="mobile-bidding-modal-content"
        style={{
          height: modalHeight
        }}>
        <div onClick={onHide} className="mobile-modal-dialog-content-rectangle">
          <img src={RectangleIcon} alt="Close" />
        </div>
        <div className="mobile-bidding-modal-header">
          <img src={CloseIcon} alt="close" onClick={onHide} className="close-icon" />
          {showCopyright && <b>כל הזכויות שמורות ל GOBEB</b>}
        </div>
        <div className="mobile-bidding-modal-body">
          {/*<h2 className="mobile-modal-title">תקציר</h2>*/}
          <h2 id={id ? `${id}-title` : undefined} className="mobile-modal-title">
            {title}
          </h2>
          <div className="mobile-bidding-content-wrapper">
            {children != null ? (
              <div className="mobile-bidding-content">{children}</div>
            ) : (
              <div
                className="mobile-bidding-content"
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MobileModal;
